import React from 'react';
import styled, { withTheme } from 'styled-components';
import { themeGet } from 'ravenjs';

import NavLogo from './NavLogo';

const AppNavStyled = styled.div`
    align-items: stretch;
    background-color: #101;
    color: #fff;
    display: flex;
    justify-content: space-between;
    min-height: 50px;
    padding: 0 15px;
    width: 100%;
    /**
     * Add all of the remaining styles from theme
     */
    ${themeGet('AppNav.styles')};
`;

const AppNav = () => (
    <AppNavStyled>
        <NavLogo />
    </AppNavStyled>
);

export default withTheme(AppNav);
